import { ClickOutsideController } from 'stimulus-use'
import * as focusTrap from 'focus-trap';

export default class extends ClickOutsideController {
    static targets = ['menubutton', 'reducedMotionButton']

    focusTrap = null

    connect() {
        this.#setReducedMotion('1' === localStorage.getItem('reduced-motion'));

        this.focusTrap = focusTrap.createFocusTrap(this.element, {
            escapeDeactivates: false,
            allowOutsideClick: true,
        });
    }

    disconnect() {
        this.hideMenu();
    }

    toggleMenu() {
        if (document.body.classList.contains('show-menu')) {
            this.hideMenu();
        } else {
            this.showMenu();
        }
    }

    showMenu() {
        document.body.classList.add('show-menu');
        this.menubuttonTarget?.setAttribute('aria-expanded', 'true');
        this.focusTrap.activate();
    }

    hideMenu() {
        document.body.classList.remove('show-menu');
        this.menubuttonTarget?.setAttribute('aria-expanded', 'false');
        this.focusTrap.deactivate();
    }

    clickOutside() {
        this.hideMenu();
    }

    toggleReducedMotion() {
        this.#setReducedMotion(!document.body.classList.contains('reduced-motion'));
    }

    #setReducedMotion(state) {
        document.body.classList.toggle('reduced-motion', state);
        localStorage.setItem('reduced-motion', state ? '1' : '0');

        for (const button of this.reducedMotionButtonTargets) {
            button.textContent = state ? 'Standard' : 'Barrierefrei';
        }
    }
}
